import type { JSX } from 'react';

import { Icon } from 'components/icon';
import { Col, Row } from 'components/grid';
import { Button } from 'components/button';
import { ButtonColors, ButtonStyleTypes } from 'types';

import * as Styles from './styles';
import { SeletOptionListProps } from './types';

const SelectOptionList = ({
  title,
  options,
  onClick,
}: SeletOptionListProps): JSX.Element => {
  return (
    <>
      {title && (
        <Row>
          <Col>
            <Styles.Title>{title}</Styles.Title>
          </Col>
        </Row>
      )}

      <Row>
        {options.map((option, idx) => (
          <Col col={6} colTablet={6} key={`${option}-${idx}`}>
            <Button
              fullWidth
              text={option}
              onClick={() => onClick(option)}
              rightIcon={<Icon.ChevronRight />}
              colorType={ButtonColors.LightGrey}
              styleType={ButtonStyleTypes.Outline}
              style={{ justifyContent: 'space-between' }}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export { SelectOptionList };
